@if (!isLoading) {
<div class="form-group">
  <label class="control-label">{{ label }}</label>
  <textarea class="form-control" [formControl]="noteControl" [formValidation]="noteControl"></textarea>
</div>
}